import parseUrl from 'src/utils/urlParser';

const environment = parseUrl();
const LogoApp = ({ height, width, img }) => <img src={`/static/${environment}/${img}`} alt={`${environment}`} height={height} width={width} />;

export default LogoApp;
